export const messageSteps = [
  {
    element: '#messageview',
    popover: {
      title: 'View Incoming Messages  ',
      showButtons: ['next', 'close'],
      description:
        '<div><ul><li> See who sent it (“Reported By”),patient name, the associated provider, date/time, and the message text.</li> </ul></div>',
    },
  },

  {
    element: '#messagefilter',
    popover: {
      title: 'Use Filter Options',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>Filter messages (e.g., “By Providers”).</li></ul></div>',
    },
  },
  {
    element: '#archivemessage',
    popover: {
      title: 'Archive Messages ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>Select items and click Archive to move them out of the main inbox. </li></ul></div>',
    },
  },
  // {
  //     element: '#messageaction',
  //     popover: {
  //     title: 'Take Action ',
  //     showButtons: ['previous','next', 'close'],
  //     description: '<div><ul><li> Icons in the Action column may let you reply, forward, or mark messages as reviewed.</li></ul></div>'
  //     },

  // },
]
